module.exports = __webpack_public_path__ + "static/media/c5_mobile.8f88b4bc.png";